module.exports = __webpack_public_path__ + "img/marketing.2dc67b90.svg";